import useTypedTranslation, {
  type TFunctionType,
} from "@/core/hooks/use-typed-translation";

/**
 * Traductions des écrans ledger (clés `ledger.*` et `nav.ledger.*`).
 *
 * Les clés vivent dans les fragments `features/ledger/i18n/*.json`
 * et seront fusionnées dans `src/locales/*.json` lors du câblage final
 * par le coordinateur : tant que la fusion n'est pas faite,
 * `TFunctionType` (dérivé de fr.json) ne les connaît pas encore, d'où
 * le cast.
 */
export const useLedgerTranslation = () => {
  const { t } = useTypedTranslation();
  return { t: (key: string) => t(key as TFunctionType) };
};
